export default "__VITE_ASSET__441b6ca2__"